var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowBarLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.802 11.15L8.85169 8.10173L8.85171 8.10171C9.01129 7.94213 9.10095 7.72569 9.10095 7.5C9.10095 7.27431 9.01129 7.05787 8.85171 6.89829C8.69213 6.73871 8.47568 6.64905 8.25 6.64905C8.02431 6.64905 7.80787 6.73871 7.64829 6.89829L3.14838 11.3982L5.802 11.15ZM5.802 11.15H14.25C14.4754 11.15 14.6916 11.2396 14.851 11.399C15.0104 11.5584 15.1 11.7746 15.1 12C15.1 12.2254 15.0104 12.4416 14.851 12.601C14.6916 12.7604 14.4754 12.85 14.25 12.85H5.802L8.85169 15.8983L8.85171 15.8983C8.93073 15.9773 8.99341 16.0711 9.03617 16.1744C9.07893 16.2776 9.10095 16.3883 9.10095 16.5C9.10095 16.6117 9.07893 16.7224 9.03617 16.8256C8.99341 16.9289 8.93073 17.0227 8.85171 17.1017C8.77269 17.1807 8.67888 17.2434 8.57564 17.2862C8.4724 17.3289 8.36175 17.3509 8.25 17.3509C8.13825 17.3509 8.0276 17.3289 7.92435 17.2862C7.82111 17.2434 7.7273 17.1807 7.64829 17.1017L3.14838 12.6018L5.802 11.15ZM18.149 22.351C18.3084 22.5104 18.5246 22.6 18.75 22.6C18.9754 22.6 19.1916 22.5104 19.351 22.351C19.5104 22.1916 19.6 21.9754 19.6 21.75V2.25C19.6 2.02457 19.5104 1.80837 19.351 1.64896C19.1916 1.48955 18.9754 1.4 18.75 1.4C18.5246 1.4 18.3084 1.48955 18.149 1.64896C17.9896 1.80837 17.9 2.02457 17.9 2.25V21.75C17.9 21.9754 17.9895 22.1916 18.149 22.351ZM2.96357 12.3258C3.0064 12.429 3.06917 12.5228 3.14829 12.6017V11.3983C3.06917 11.4772 3.0064 11.571 2.96357 11.6742C2.92071 11.7775 2.89866 11.8882 2.89866 12C2.89866 12.1118 2.92071 12.2225 2.96357 12.3258Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBarLeft);
export default __webpack_public_path__ + "static/media/arrow-bar-left.9cc85cd21414aecf0f6413c369c922d9.svg";
export { ForwardRef as ReactComponent };